/** @module resolve */ /** for typedoc */
export * from "./interface";
export * from "./resolvable";
export * from "./resolveContext";
export * from "./resolveInjector";



/** WEBPACK FOOTER **
 ** ./resolve/module.ts
 **/